"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _knock = require("../../../actions/knock");
function cancelPresenterKnock(_ref, payload) {
  var dispatch = _ref.dispatch;
  dispatch((0, _knock.cancelKnock)(payload));
}
var _default = exports["default"] = cancelPresenterKnock;